import * as actionTypes from './actionTypes';

export const fetchAisVersionList = () => ({
  type: actionTypes.FETCH_AIS_VERSION_LIST,
});

export const fetchAisVersionListSuccess = (data) => ({
  type: actionTypes.FETCH_AIS_VERSION_LIST_SUCCESS,
  data,
});

export const checkAisVersions = () => ({
  type: actionTypes.CHECK_AIS_VERSIONS,
});

export const exportAisVersions = () => ({
  type: actionTypes.EXPORT_AIS_VERSIONS,
});

export const exportAisVersionsSuccess = () => ({
  type: actionTypes.EXPORT_AIS_VERSIONS_SUCCESS,
});

export const exportAisVersionsFailure = (error) => ({
  type: actionTypes.EXPORT_AIS_VERSIONS_FAILURE,
  error,
});
